<template>
<v-container>
  <div v-if="$unit.uuid != ''">
    <h1>Digitaler Zonenplan {{ unitName }}</h1>
    <p>In nur vier Schritten können Sie Ihren Zonenplan hochladen und mit detaillierten Angaben ergänzen:</p>
  </div>
  <div class="tutorsteps">
    <v-row>
      <v-col>
        <v-card elevation="0">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="20" fill="black" fill-opacity="0.1"/><path d="M21 10H14C13.4696 10 12.9609 10.2107 12.5858 10.5858C12.2107 10.9609 12 11.4696 12 12V28C12 28.5304 12.2107 29.0391 12.5858 29.4142C12.9609 29.7893 13.4696 30 14 30H26C26.5304 30 27.0391 29.7893 27.4142 29.4142C27.7893 29.0391 28 28.5304 28 28V17L21 10Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M21 10V17H28" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          <p><b>Erforderliche Daten bei Ihrem GIS-Anbieter bestellen</b></p>
          <p>Für Ihren digitalen Zonenplan benötigen Sie die Daten der Grundnutzung und der amtlichen Vermessung Ihrer Gemeinde.</p>
        </v-card>
      </v-col>
      <v-col>
        <v-card elevation="0">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="20" fill="black" fill-opacity="0.1"/><path d="M29 23V27C29 27.5304 28.7893 28.0391 28.4142 28.4142C28.0391 28.7893 27.5304 29 27 29H13C12.4696 29 11.9609 28.7893 11.5858 28.4142C11.2107 28.0391 11 27.5304 11 27V23" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M25 16L20 11L15 16" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M20 11V23" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          <p><b>Erforderliche Daten hochladen</b></p>
          <p>Laden Sie die erhaltenen Daten hoch. Die Genauigkeit Ihres Zonenplans steigt mit weiteren Datensätzen deutlich. </p>
        </v-card>
      </v-col>
      <v-col>
        <v-card elevation="0">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="20" fill="black" fill-opacity="0.1"/><path d="M25 11.0001C25.2626 10.7374 25.5744 10.5291 25.9176 10.3869C26.2608 10.2448 26.6286 10.1716 27 10.1716C27.3714 10.1716 27.7392 10.2448 28.0824 10.3869C28.4256 10.5291 28.7374 10.7374 29 11.0001C29.2626 11.2627 29.471 11.5745 29.6131 11.9177C29.7553 12.2608 29.8284 12.6286 29.8284 13.0001C29.8284 13.3715 29.7553 13.7393 29.6131 14.0825C29.471 14.4256 29.2626 14.7374 29 15.0001L15.5 28.5001L10 30.0001L11.5 24.5001L25 11.0001Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          <p><b>Detailierte Angaben ergänzen</b></p>
          <p>Ergänzen Sie Ihren digitalen Zonenplan mit detaillierten Angaben direkt online.</p>
        </v-card>
      </v-col>
      <v-col>
        <v-card elevation="0">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="20" fill="black" fill-opacity="0.1"/><path d="M9 14V30L16 26L24 30L31 26V10L24 14L16 10L9 14Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M16 10V26" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M24 14V30" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          <p><b>Ihr digitaler Zonenplan generieren</b></p>
          <p>Starten Sie die automatische Generierung Ihres digitalen Zonenplans.</p>
        </v-card>
      </v-col>
    </v-row>
  </div>
  <h1>Dateiuploads</h1>
  <p>Bitte laden Sie die Daten als SHP-File hoch. Die Datei muss die Flächen-Geometrien gemäss der Spezifikation unten beinhalten.</p>
  <InputFile inputName="Grundnutzung" toSpecifikation="/docs/zp" uploaderElementId="1" inputFileType='zp' />
  <InputFile inputName="Überlagerungen" toSpecifikation="/docs/ovl" uploaderElementId="2" inputFileType='ovl' />
  <InputFile inputName="Strassenklassierung" toSpecifikation="/docs/str" uploaderElementId="3" inputFileType='str' />
  <InputFile inputName="Parzellen" toSpecifikation="/docs/sit" uploaderElementId="4" inputFileType='sit' />

</v-container>
</template>

<script>
import InputFile from '@/components/InputFile.vue'

export default {
  name: 'Index',
  data () {
    return {
      zpStatus: 'progress',
      unitId: this.$unit.uuid,
      unitName: this.$unit.name
    }
  },
  components: {
    InputFile
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
h1 {
  font-size: 30px;
  margin-bottom: 10px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.hello {
  margin-bottom: 20px;
  margin-left: 100px;
  margin-right: 100px;
}
.simpart {
  min-height: 200px;
}
.simpart-item {
  padding: 10px;
  text-align: center;
}
.option {
  background-color: rgb(214, 214, 214);
  height: 100%;
  padding: 20px;
  text-align: center;
}
h2 {
  padding-bottom: 10px;
}
.tutorsteps {
  margin: 40px 0;
}
.suboptionslist {
  text-align: left;
}
.suboptionslist li {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Index.vue